var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{attrs:{"height":_vm.maxSize,"max-height":_vm.maxSize,"max-width":_vm.maxSize,"src":_vm.localSrc,"width":_vm.maxSize,"contain":_vm.contain}})
}
var staticRenderFns = []

export { render, staticRenderFns }